"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAINTENANCE_TYPE = void 0;
var MAINTENANCE_TYPE;
(function (MAINTENANCE_TYPE) {
    MAINTENANCE_TYPE["CLEAN_DELETED_MOBILE_USERS"] = "CLEAN_DELETED_MOBILE_USERS";
    MAINTENANCE_TYPE["CLEAN_DELETED_WEB_USERS"] = "CLEAN_DELETED_WEB_USERS";
    MAINTENANCE_TYPE["CLEAN_LICENSE"] = "CLEAN_LICENSE";
    MAINTENANCE_TYPE["CLEAN_OTHER_PROBLEMS"] = "CLEAN_OTHER_PROBLEMS";
    MAINTENANCE_TYPE["HANDLE_OLD_RECORDS"] = "HANDLE_OLD_RECORDS";
    MAINTENANCE_TYPE["HANDLE_OLD_UPLOADS"] = "HANDLE_OLD_UPLOADS";
    MAINTENANCE_TYPE["PROPAGATE_TEMPLATE"] = "PROPAGATE_TEMPLATE";
    MAINTENANCE_TYPE["MAINTAIN_LOG_PARTITIONS"] = "MAINTAIN_LOG_PARTITIONS";
    MAINTENANCE_TYPE["MAINTAIN_TABLE_OPTIMIZATIONS"] = "MAINTAIN_TABLE_OPTIMIZATIONS";
    MAINTENANCE_TYPE["UPDATE_QUERY_ATTRIBUTES"] = "UPDATE_QUERY_ATTRIBUTES";
    MAINTENANCE_TYPE["CLEAN_DUPLICATED_CLIENT_LINKS"] = "CLEAN_DUPLICATED_CLIENT_LINKS";
    MAINTENANCE_TYPE["MIGRATION"] = "MIGRATION";
    MAINTENANCE_TYPE["ANALYZE_DATABASE_STRUCTURE"] = "ANALYZE_DATABASE_STRUCTURE";
    MAINTENANCE_TYPE["ANALYZE_QUERIES"] = "ANALYZE_QUERIES";
    MAINTENANCE_TYPE["MANAGE_ACCOUNT_LIFECYCLE_RULE"] = "MANAGE_ACCOUNT_LIFECYCLE_RULE";
    MAINTENANCE_TYPE["CLEAN_ZOMBI_CLIENTS"] = "CLEAN_ZOMBI_CLIENTS";
    MAINTENANCE_TYPE["MAINTAIN_USAGE_TABLE"] = "MAINTAIN_USAGE_TABLE";
    MAINTENANCE_TYPE["CHECK_CLIENT_STATUS"] = "CHECK_CLIENT_STATUS";
    MAINTENANCE_TYPE["TABLE_ANALYSIS"] = "TABLE_ANALYSIS";
    MAINTENANCE_TYPE["DAILY_HEALTH_CHECK"] = "DAILY_HEALTH_CHECK";
    MAINTENANCE_TYPE["THREE_MONTH_CHECK"] = "THREE_MONTH_CHECK";
    MAINTENANCE_TYPE["UPDATE_ITEM_TEAM_LEADER_LINKS"] = "UPDATE_ITEM_TEAM_LEADER_LINKS";
    MAINTENANCE_TYPE["CHECK_AND_KILL_BLOCKED_QUERIES"] = "CHECK_AND_KILL_BLOCKED_QUERIES";
    MAINTENANCE_TYPE["UPDATE_USAGE_TABLE_AGGREGATED"] = "UPDATE_USAGE_TABLE_AGGREGATED";
    MAINTENANCE_TYPE["UPDATE_USAGE_TABLE_AGGREGATED_PER_CLIENT"] = "UPDATE_USAGE_TABLE_AGGREGATED_PER_CLIENT";
    MAINTENANCE_TYPE["CLEAN_EVENTS_STATUSES"] = "CLEAN_EVENTS_STATUSES";
    MAINTENANCE_TYPE["FIX_PICTURE_SUBMISSION_ITEMS"] = "FIX_PICTURE_SUBMISSION_ITEMS";
    MAINTENANCE_TYPE["CLEAN_CRISP_CLIENTS"] = "CLEAN_CRISP_CLIENTS";
    MAINTENANCE_TYPE["CREATE_REPEATING_EVENTS"] = "CREATE_REPEATING_EVENTS";
    MAINTENANCE_TYPE["CREATE_DAILY_RECAP_CLIENT_BY_STATUS"] = "CREATE_DAILY_RECAP_CLIENT_BY_STATUS";
    MAINTENANCE_TYPE["UPDATE_CUSTOMERS_FROM_ERP"] = "UPDATE_CUSTOMERS_FROM_ERP";
    MAINTENANCE_TYPE["UPDATE_DISCOUNTS_FROM_ERP"] = "UPDATE_DISCOUNTS_FROM_ERP";
    MAINTENANCE_TYPE["UPDATE_ORDERS_FROM_ERP"] = "UPDATE_ORDERS_FROM_ERP";
    MAINTENANCE_TYPE["UPDATE_PACKAGINGS_FROM_ERP"] = "UPDATE_PACKAGINGS_FROM_ERP";
    MAINTENANCE_TYPE["UPDATE_PRODUCTS_FROM_ERP"] = "UPDATE_PRODUCTS_FROM_ERP";
    MAINTENANCE_TYPE["UPDATE_PRICES_FROM_ERP"] = "UPDATE_PRICES_FROM_ERP";
    MAINTENANCE_TYPE["UPDATE_STOCK_FROM_ERP"] = "UPDATE_STOCK_FROM_ERP";
    MAINTENANCE_TYPE["UPDATE_LOYALTY_POINTS"] = "UPDATE_LOYALTY_POINTS";
    MAINTENANCE_TYPE["UPDATE_PROBLEMATIC_PHONE_NUMBERS"] = "UPDATE_PROBLEMATIC_PHONE_NUMBERS";
    MAINTENANCE_TYPE["CLEAN_CALENDAR_EVENTS"] = "CLEAN_CALENDAR_EVENTS";
    MAINTENANCE_TYPE["UPDATE_STRIPE_OBJECTS"] = "UPDATE_STRIPE_OBJECTS";
})(MAINTENANCE_TYPE || (exports.MAINTENANCE_TYPE = MAINTENANCE_TYPE = {}));
